import React from 'react';
import translate from '@/utils/translate';
import type {CampaignProps} from '@/types/campaign';
import BriefField from '../../shared/BriefField';
import BriefItemHtml from '../../shared/BriefItemHtml';
import BriefSection from '../../shared/BriefSection';
import BriefTag from '../../shared/BriefTag';
import styles from './GeneralDetails.module.scss';

interface GeneralDetailsProps {
  campaign: CampaignProps;
}

function GeneralDetails({campaign}: GeneralDetailsProps) {
  const verticalTags = campaign.verticalTags ?? [];

  if (!campaign.descriptionHtml && !verticalTags.length) {
    return null;
  }

  return (
    <BriefSection title={translate('General details')}>
      <div className={styles.fields}>
        {campaign.descriptionHtml ? (
          <BriefField label={translate('About the brand and campaign')}>
            <BriefItemHtml contentHtml={campaign.descriptionHtml} />
          </BriefField>
        ) : null}
        {verticalTags.length > 0 && (
          <BriefField label={translate('Verticals')}>
            <div className={styles.chips}>
              {verticalTags.map((tag) => (
                <BriefTag key={tag.id} label={tag.displayText ?? tag.name} />
              ))}
            </div>
          </BriefField>
        )}
      </div>
    </BriefSection>
  );
}

export default GeneralDetails;
